const GetCreditorUnparsedValue = (obj: any) => {
  let creditor = "";
  for (const key in obj) {
    let sname = obj[key].name;
    for (const skey in sname) {
      if (sname[skey].unparsed) {
        creditor = sname[skey].unparsed;
      }
    }
  }
  return creditor;
};

export default GetCreditorUnparsedValue;
